import React from 'react';

import { Container, InnerContainer, SkeletonLogo, LinksContainer, SkeletonLink } from './placeholder-header.styles';

/**
 * Renders a placeholder header skeleton to display before dispensary data is loaded.
 * This component mirrors the structure of the StoreFrontHeader to minimize layout shift (CLS)
 * and maintain good Largest Contentful Paint (LCP) metrics.
 */
export const PlaceholderHeader = (): JSX.Element => (
  <Container data-testid='placeholder-header'>
    <InnerContainer>
      <SkeletonLogo aria-hidden='true' />
      <LinksContainer>
        <SkeletonLink aria-hidden='true' />
      </LinksContainer>
    </InnerContainer>
  </Container>
);
